//Generated File 
export const ApprovalPending = `ApprovalPending`;
export const ApprovalRejected = `ApprovalRejected`;
export const ApprovalReturned = `ApprovalReturned`;
export const Cancelled = `Cancelled`;
export const Draft = `Draft`;
export const Stable = `Stable`;
